import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { FairColorsService } from '@core/services/fair-colors/fair-colors.service';

/**
 * Card-on-coloured-background shell. It wraps the whole public onboarding area (landing, stop
 * form, both success pages), which is why the fair colours are applied here instead of in each
 * page: one place covers every screen and the dialogs they open, and survives navigation
 * between them without the colours flickering off in between.
 */
@Component({
  selector: 'recrewt-info-card-layout',
  templateUrl: './info-card-layout.component.html',
  styleUrls: ['./info-card-layout.component.scss'],
  standalone: false,
})
export class InfoCardLayoutComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private fairColors = inject(FairColorsService);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    // Query params live on the router state, so the session id of the child route is readable
    // here. ponytail: costs one extra public session GET per onboarding visit — cheap next to
    // threading the already-loaded session up from four different pages.
    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => this.fairColors.applyForSession(params.get('s')));
  }

  ngOnDestroy(): void {
    this.fairColors.clear();
  }
}
